import { Button } from "@/v2-components/ui/button";
import { useTrans } from "@/utils/useTrans";
import Dk3SizeGuideSheet from "@/components/tactsuit/tactglove-dk3/Dk3SizeGuideSheet";
import Image from "next/image";
import { useState } from "react";

export default function Dk3SizeGuide() {
  const { t } = useTrans(["tactsuit"]);
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="w-full bg-white px-4">
        <div className="mx-auto w-full max-w-screen-max">
          {/* 모바일: 카드형 (이미지 상단 + 텍스트/버튼 하단 center). 데스크톱: 풀-bleed 이미지 + overlay. */}
          <div className="relative w-full overflow-hidden rounded-2xl bg-coolgray-10 laptop:bg-[#1a1a1a]">
            {/* Image — 모바일 aspect 328/240 (Figma 비율), 데스크톱 320px 고정 */}
            <div className="relative aspect-[328/240] w-full laptop:aspect-auto laptop:h-[320px]">
              <Image
                src="/images/tactsuit/tactglove-dk3/size-guide-mobile.jpg"
                alt=""
                fill
                className="object-cover laptop:hidden"
                sizes="100vw"
              />
              <Image
                src="/images/tactsuit/tactglove-dk3/size-guide.jpg"
                alt=""
                fill
                className="hidden object-cover laptop:block"
                sizes="1312px"
              />
            </div>

            {/* 데스크톱: 이미지 위 overlay 좌측 정렬 텍스트 + CTA */}
            <div className="absolute inset-0 hidden flex-col items-start justify-center gap-6 px-16 laptop:flex">
              <div className="flex flex-col gap-3">
                <h2 className="text-[32px] font-400 leading-10 text-white">
                  {t("Which size is right for you?")}
                </h2>
                <p className="text-sm font-400 leading-[18px] tracking-[0.25px] text-white">
                  {t(
                    "Find your fit in S, M, L, or XL with our quick measurement guide.",
                  )}
                </p>
              </div>
              <Button
                variant="blue-fill"
                shape="pill"
                size="none"
                className="h-10 px-6 text-xs font-600 leading-4 tracking-[0.1px] text-white"
                onClick={() => setOpen(true)}
              >
                {t("Find Yours")}
              </Button>
            </div>

            {/* 모바일: 이미지 아래 center-aligned 텍스트 + CTA */}
            <div className="flex flex-col items-center gap-6 px-6 pb-6 pt-3 text-center laptop:hidden">
              <div className="flex flex-col gap-3">
                <h2 className="text-2xl font-400 leading-8 text-coolgray-90">
                  {t("Which size is right for you?")}
                </h2>
                <p className="text-sm font-400 leading-[18px] tracking-[0.25px] text-coolgray-90">
                  {t(
                    "Find your fit in S, M, L, or XL with our quick measurement guide.",
                  )}
                </p>
              </div>
              <Button
                variant="blue-fill"
                shape="pill"
                size="none"
                className="h-10 px-6 text-xs font-600 leading-4 tracking-[0.1px] text-white"
                onClick={() => setOpen(true)}
              >
                {t("Find Yours")}
              </Button>
            </div>
          </div>
        </div>
      </section>
      <Dk3SizeGuideSheet open={open} onOpenChange={setOpen} />
    </>
  );
}
